/* eslint-disable react/jsx-no-target-blank */
import * as React from 'react';
import { Avatar } from '@cian/ui-kit';
import * as styles from './BuilderLogo.css';

export interface IBuilderLogoProps {
  src?: string | null;
  type: 'builder' | 'agency';
}

export const BuilderLogo: React.FC<IBuilderLogoProps> = props => {
  const { src, type } = props;

  return (
    <div className={styles['container']}>
      <Avatar src={src} size={48} type={type} hideBorder />
    </div>
  );
};
